import { render, staticRenderFns } from "./ArchiveEmployeeDialog.vue?vue&type=template&id=469b3c52&scoped=true"
import script from "./ArchiveEmployeeDialog.vue?vue&type=script&lang=js"
export * from "./ArchiveEmployeeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469b3c52",
  null
  
)

export default component.exports